import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

/**
 * Native toolbar / bar button (Hotwire Native bridge).
 * Pairs with ButtonComponent on iOS / Android.
 *
 * @example
 *   <a href="/profile" data-controller="bridge--button" data-bridge-title="Profile">Profile</a>
 */
export default class extends BridgeComponent {
  static component = "button"

  connect() {
    super.connect()
    if (!this.enabled) return

    const title = this.bridgeElement.bridgeAttribute("title") || this.bridgeElement.title
    this.send("connect", { title }, () => {
      this.bridgeElement.click()
    })
  }
}
